import { differenceWith, isEqual, omit } from 'lodash-es'

import { CartLine } from '../../../__generated__/graphql/catalog/graphql'

import { CartStoreLineItem } from './useCartStore'
import { LocalCart } from './useLocalCart'

export function areCartLinesEqual(
  itemA: Omit<CartLine, 'cost' | 'discountAllocations' | 'id'>,
  itemB: Omit<CartLine, 'cost' | 'discountAllocations' | 'id'>
): boolean {
  return isEqual(
    {
      attributes: itemA.attributes?.map(attr =>
        omit(attr, ['__typename', '_collectionAttribution'])
      ),
      sku: itemA.sku,
    },
    {
      attributes: itemB.attributes?.map(attr =>
        omit(attr, ['__typename', '_collectionAttribution'])
      ),
      sku: itemB.sku,
    }
  )
}

export function identifyCartLinesForMerge(
  sourceLines: Omit<CartLine, 'cost' | 'discountAllocations'>[],
  targetLines: Omit<CartLine, 'cost' | 'discountAllocations'>[]
): Omit<CartLine, 'cost' | 'discountAllocations'>[] {
  return differenceWith(sourceLines, targetLines, areCartLinesEqual)
}

export function augmentLocalCartWithCartStoreIds(
  localCart: LocalCart,
  cartStoreLines: CartStoreLineItem[]
): LocalCart {
  return Object.entries(localCart).reduce<LocalCart>((newCart, [oldKey, value]) => {
    const matchingCartStoreLine = cartStoreLines.find(e =>
      areCartLinesEqual(e, {
        ...value,
        attributes: Object.entries(value.properties)
          .filter(([_key, value]) => value !== undefined)
          .map(([key, value]) => ({
            key: key,
            value: value!,
          })),
      })
    )
    const newKey = matchingCartStoreLine ? matchingCartStoreLine.cartLineId : oldKey

    newCart[newKey] = {
      ...value,
      key: newKey,
    }

    return newCart
  }, {})
}
